import { HttpClient } from "@angular/common/http";
import { AbstractService } from "../../core/AbstractService";
import { TypeInterventionRequest } from "../../data/http/requests/typeintervention.request";
import { env } from "../../../env/env";
import { Injectable, Injector } from "@angular/core";
import { TypeInterventionResponse } from "../../data/http/responses/typeintervention.response";
import { AuthService } from "../auth/auth.service";
import { AppService } from "../../core/app.service";
@Injectable({
    providedIn: 'root'
})
export class TypeInterventionService extends AbstractService<TypeInterventionRequest, TypeInterventionResponse> {

    constructor(http: HttpClient, injector: Injector, appService: AppService) {
        // Do not rely on a CookiesService import here; pass null and let AbstractService use AppService
        super(`${env.apiUrl}type-intervention`, http, null, appService ); 
    }
/* 
    // Exemple d'une méthode personnalisée qui retourne un Observable
    getActiveUsers(): Observable<ApiResponse<TypeInterventionResponse[]>> {
        // Vous pouvez utiliser les méthodes héritées ou créer des méthodes spécifiques
        return this.http.get<ApiResponse<TypeInterventionResponse[]>>(`${this.baseUrl}`).pipe(
            catchError(this.handleError) // Utilisez la gestion d'erreur héritée
        );
    } */
}